/** Element listy języków (z API lub stałej – wszędzie używamy kodów, nie id). */
export interface ILanguage {
  code: string;
  name: string;
}

export interface ILanguagesResponse {
  data: ILanguage[];
}

/** Stała lista obsługiwanych języków (spójna z backendem). Używana gdy API niedostępne. */
export const SUPPORTED_LANGUAGES: ILanguage[] = [
  { code: 'pl', name: 'Polski' },
  { code: 'en', name: 'English' },
  { code: 'ru', name: 'Русский' },
  { code: 'uk', name: 'Українська' }
];
